import { FieldError, SegmentButton, ToggleRow, inputClass, textareaClass } from "./primitives";

// One template's editable config: how it's sent (Chat360-approved template or
// direct text), its name or body, and whether the send fires at all.
//
// `row` is a row from GET /superadmin/tenants/{id}/templates — it carries the
// catalog metadata (label, allows_direct, default_enabled, platform_default)
// alongside this brand's overlay (send_mode, template_name, body, enabled).
// `onChange(patch)` merges `patch` back onto the row.
//
// `locked` (from journey.stageTemplateLock): the owning stage is hidden or
// WhatsApp-captured, so the server already forces `enabled` off on save — the
// switch here just reflects and locks that rather than allowing a value
// that would be silently overwritten.
export default function TemplateFields({ row, onChange, locked = false, lockedReason = "", error = "" }) {
  const direct = row.send_mode === "direct";
  const enabledEffective = locked ? false : row.enabled == null ? row.default_enabled : row.enabled;

  return (
    <div className="flex flex-col gap-5">
      <div>
        {row.allows_direct && (
          <div className="mb-[10px] flex gap-2">
            <SegmentButton active={!direct} onClick={() => onChange({ send_mode: "template" })}>
              WhatsApp template
            </SegmentButton>
            <SegmentButton active={direct} onClick={() => onChange({ send_mode: "direct" })}>
              Direct text
            </SegmentButton>
          </div>
        )}
        <div className="mb-[6px] text-[12px] font-medium text-[#6B7280]">
          {direct ? "Message text" : "Chat360 template name"}
        </div>
        {direct ? (
          <textarea
            className={`${textareaClass} min-h-[96px]`}
            value={row.body || ""}
            onChange={(e) => onChange({ body: e.target.value })}
            aria-label={`Message text for ${row.label}`}
          />
        ) : (
          <input
            type="text"
            className={inputClass}
            value={row.template_name || ""}
            placeholder={row.platform_default || ""}
            onChange={(e) => onChange({ template_name: e.target.value })}
            aria-label={`Template name for ${row.label}`}
          />
        )}
        <FieldError>{error}</FieldError>
      </div>

      <ToggleRow
        title="Send automatically"
        status={locked ? lockedReason : ""}
        checked={!!enabledEffective}
        disabled={locked}
        onChange={(on) => onChange({ enabled: on })}
      />
    </div>
  );
}
